import React, { useImperativeHandle, useRef, useState } from 'react';
import { useReactive } from 'ahooks';
import { Input, Button, Dropdown, message } from 'kenshin';
import {
  PlusOutlined,
  SearchOutlined,
  MoreOutlined,
  EditOutlined,
  PushpinOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import styles from './index.less';

// 模拟数据
const mockConversations = [
  {
    id: '1',
    title: '对话1',
    time: '1分钟前',
    thumbUrl: 'https://picsum.photos/seed/conv1/40/40',
    pinned: false,
  },
  {
    id: '2',
    title: '对话2',
    time: '1天前',
    thumbUrl: 'https://picsum.photos/seed/conv2/40/40',
    pinned: false,
  },
];

const ConversationList = React.forwardRef((props, ref) => {
  const { currentId, onSelect, onNew } = props;
  const [searchVisible, setSearchVisible] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [menuVisible, setMenuVisible] = useState(null);

  const state = useReactive({
    conversations: [...mockConversations],
  });

  useImperativeHandle(ref, () => ({
    refresh: () => {
      // 后续对接接口刷新列表
    },
  }));

  // 右键菜单
  const handleContextMenu = (e, conv) => {
    e.preventDefault();
    setMenuVisible(conv.id);
  };

  const handleMenuClick = ({ key }, conv) => {
    switch (key) {
      case 'rename':
        message.info('重命名功能待开发');
        break;
      case 'pin':
        conv.pinned = !conv.pinned;
        message.success(conv.pinned ? '已置顶' : '已取消置顶');
        break;
      case 'delete':
        state.conversations = state.conversations.filter(
          (c) => c.id !== conv.id,
        );
        message.success('已删除');
        break;
      default:
        break;
    }
    setMenuVisible(null);
  };

  const menuItems = (conv) => (
    <Dropdown.Menu>
      <Dropdown.Item>
        <div onClick={() => handleMenuClick({ key: 'rename' }, conv)}>重命名</div>
      </Dropdown.Item>
      <Dropdown.Item>
        <div onClick={() => handleMenuClick({ key: 'pin' }, conv)}>
          {conv.pinned ? '取消置顶' : '置顶'}
        </div>
      </Dropdown.Item>
      <Dropdown.Item>
        <div
          onClick={() => handleMenuClick({ key: 'delete' }, conv)}
          style={{ color: '#ff4d4f' }}
        >
          删除
        </div>
      </Dropdown.Item>
    </Dropdown.Menu>
  );

  const filteredConversations = state.conversations.filter((c) =>
    c.title.toLowerCase().includes(searchValue.toLowerCase()),
  );

  // 置顶的排前面
  const sortedConversations = [
    ...filteredConversations.filter((c) => c.pinned),
    ...filteredConversations.filter((c) => !c.pinned),
  ];

  return (
    <div className={styles.conversationList}>
      {/* 顶部操作栏 */}
      <div className={styles.listHeader}>
        <Button
          type="primary"
          size="small"
          icon={<PlusOutlined />}
          onClick={onNew}
          className={styles.newBtn}
        >
          新建对话
        </Button>
        <div className={styles.headerActions}>
          {searchVisible ? (
            <Input
              size="small"
              placeholder="搜索对话..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              autoFocus
              onBlur={() => {
                if (!searchValue) setSearchVisible(false);
              }}
              className={styles.searchInput}
              prefix={<SearchOutlined />}
            />
          ) : (
            <SearchOutlined
              className={styles.actionIcon}
              onClick={() => setSearchVisible(true)}
            />
          )}
        </div>
      </div>

      {/* 对话列表 */}
      <div className={styles.listBody}>
        {sortedConversations.map((conv) => (
          <div
            key={conv.id}
            className={`${styles.convItem} ${currentId === conv.id ? styles.active : ''}`}
            onClick={() => onSelect(conv.id)}
            onContextMenu={(e) => handleContextMenu(e, conv)}
          >
            <div className={styles.convThumb}>
              {conv.thumbUrl ? (
                <img src={conv.thumbUrl} alt="" />
              ) : (
                <div className={styles.convThumbPlaceholder}>AI</div>
              )}
            </div>
            <div className={styles.convInfo}>
              <div className={styles.convTitle}>{conv.title}</div>
              <div className={styles.convTime}>{conv.time}</div>
            </div>
            {/* <Dropdown
              overlay={menuItems(conv)}
              trigger="click"
              visible={menuVisible === conv.id}
              onVisibleChange={(v) => setMenuVisible(v ? conv.id : null)}
            >
              <div
                className={styles.moreBtn}
                onClick={(e) => e.stopPropagation()}
              >
                <MoreOutlined />
              </div>
            </Dropdown> */}
          </div>
        ))}
        {sortedConversations.length === 0 && (
          <div className={styles.emptyTip}>暂无对话</div>
        )}
      </div>
    </div>
  );
});

export default ConversationList;
